import React, { useEffect, useRef, useState } from "react";
import txnDI from "@frameworks/web/components/Reports/TransactionHistory/di/servicelocator";
const LoadDataOnscroll = () => {
    const scrollRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const handleScroll = () => {
        if (isLoading)
            return;
        const bottomEl = scrollRef.current;
        if (bottomEl) {
            const rect = bottomEl.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const isNearBottom = rect.top <= windowHeight + 100;
            if (isNearBottom) {
                setIsLoading(true);
                txnDI.transactionHistory
                    .getAlltxnDataNextpage()
                    .finally(() => setIsLoading(false));
            }
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isLoading]);
    return React.createElement("div", { ref: scrollRef });
};
export default LoadDataOnscroll;
